import endpoints from "../config/endpoints";
import api from "../config/axios";

export const GetAllProductAttributesWithValues = async (params) => {
    let query;

    // Handle array parameters specially (like attributeIds and productIds)
    if (params.productIds && Array.isArray(params.productIds)) {
        const productIdsQuery = params.productIds.map(id => `productIds=${id}`).join('&');
        const otherParams = { ...params };
        delete otherParams.productIds;
        const otherQuery = new URLSearchParams(otherParams).toString();
        query = otherQuery ? `${productIdsQuery}&${otherQuery}` : productIdsQuery;
    } else if (params.attributeIds && Array.isArray(params.attributeIds)) {
        const attributeIdsQuery = params.attributeIds.map(id => `attributeIds=${id}`).join('&');
        const otherParams = { ...params };
        delete otherParams.attributeIds;
        const otherQuery = new URLSearchParams(otherParams).toString();
        query = otherQuery ? `${attributeIdsQuery}&${otherQuery}` : attributeIdsQuery;
    } else {
        query = new URLSearchParams(params).toString();
    }
    
    const url = `${endpoints.Attributes.GetAllProductAttributesWithValues}?${query}`;

    const response = await api.get(url);

    // Return the full response with pagination metadata
    return {
        data: response.data.data || [],
        pagination: {
            pageIndex: response.data.pageIndex,
            pageSize: response.data.pageSize,
            totalRecord: response.data.totalRecord,
        },
        status: response.data.status,
        statusCode: response.data.statusCode,
        message: response.data.message,
    };
};

// Alias for backward compatibility
export const getAttributes = GetAllProductAttributesWithValues;

const attributeService = {
    getAttributes,
};

export default attributeService;
